"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCompliancePresetSchema = exports.APosShippingRestrictionsSchema = exports.APosPresetVerificationMethodSchema = exports.APosAgeRestrictionTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosAgeRestrictionTypeSchema = zod_1.z.enum(['none', '18+', '21+', 'custom']);
exports.APosPresetVerificationMethodSchema = zod_1.z.enum(['manual', 'id_scan', 'database', 'document', 'biometric']);
exports.APosShippingRestrictionsSchema = zod_1.z.object({
    allowedStates: zod_1.z.array(zod_1.z.string().length(2)).optional(),
    blockedStates: zod_1.z.array(zod_1.z.string().length(2)).optional(),
    requireAdultSignature: zod_1.z.boolean().default(false),
    licensedCarriersOnly: zod_1.z.boolean().default(false),
    customsDeclaration: zod_1.z.string().optional(),
});
exports.APosCompliancePresetSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    presetId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(200),
    ageRestrictionType: exports.APosAgeRestrictionTypeSchema.default('none'),
    customMinimumAge: zod_1.z.number().int().min(0).max(120).optional(),
    verificationMethod: exports.APosPresetVerificationMethodSchema.optional(),
    customerRegistrationRequired: zod_1.z.boolean().default(false),
    acceptStoredVerification: zod_1.z.boolean().default(true),
    maxPerTransaction: zod_1.z.number().int().min(0).optional(),
    dailyPurchaseLimit: zod_1.z.number().int().min(0).optional(),
    weeklyPurchaseLimit: zod_1.z.number().int().min(0).optional(),
    // Phase G (O19) additive
    complianceCategory: zod_1.z.string().optional(),
    licenseRequired: zod_1.z.boolean().default(false),
    licenseType: zod_1.z.enum(['alcohol', 'cannabis', 'tobacco', 'firearms']).optional(),
    shippingRestrictions: exports.APosShippingRestrictionsSchema.optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=compliance-preset.schema.js.map